import React from "react";
import FooterStyle from "../assets/stylesheets/Footer.module.css";
import { Instagram } from "lucide-react";
import SignupForm from "./SignupForm";
import { Logo } from "../assets/logo/Logo";

// import Logger from "../utils/logger";

// const log = Logger.create('Footer');

export default function Footer({ categoryStyle = false }) {
  return (
    <footer
      className={`${FooterStyle["footer-wrapper"]} ${
        categoryStyle ? FooterStyle["footer-category"] : ""
      }`}
    >
      <div className={FooterStyle["container"]}>
        <div className={FooterStyle["footer-top"]}>
          <div className={FooterStyle["footer-column"]}>

            <ul className={FooterStyle["footer-logo-container"]}>
              <a href="/" className={FooterStyle["footer-logo-link"]}>
                <Logo
                  className={FooterStyle["footer-logo"]}
                  aria-label="FarmCiti Logo"
                />
              </a>
         
            </ul>
          </div>
          <div className={FooterStyle["footer-column"]}>
            <h4 className={FooterStyle["footer-heading"]}>FarmCiti Canada</h4>
            <ul className={FooterStyle["footer-list"]}>
              <li>
                <p >FarmCiti is a digital platform that connects people with authentic farm experiences across Canada, from pick-your-own to seasonal events.</p>
              </li>
            </ul>
          </div>
 
          <div className={FooterStyle["footer-column"]}>
            <SignupForm />
          </div>
        </div>
        <hr />
        <div className={FooterStyle["footer-bottom"]}>
          <div className={FooterStyle["footer-bottom-left"]}>
            <span>© FarmCiti 2025. All rights reserved</span>
            <a href="#" className={FooterStyle["footer-link"]}>
              Terms
            </a>
          </div>
          <div className={FooterStyle["footer-bottom-right"]}>
            <span>Stay with us</span>
            <a
              href="https://www.instagram.com/farmciti.ca"
              className={FooterStyle["social-link"]}
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
      
    </footer>
  );
}
